export default __webpack_public_path__ + "static/media/main_img.d625fd36.png";